/**
 * commonView
 * @Object {Object} axboot.commonView
 */
axboot.commonView = {};

/**
 * 1, 2를 믹스한 새로운 오브젝트를 반환
 * @param _obj1
 * @param _obj2
 */
axboot.extend = function (_obj1, _obj2) {
    return $.extend({}, _obj1, _obj2);
};
axboot.viewExtend = function (_obj1, _obj2) {
    if (typeof _obj2 === "undefined") {
        return $.extend({}, axboot.commonView, _obj1);
    } else {
        return $.extend({}, _obj1, _obj2);
    }
};

/**
 * 페이지에서 사용하는
 * @method axboot.actionExtend
 * @param {Object} [_actionThis]
 * @param {Object} _action
 * @example
 * ```js
 *
 * // ACTION 이름은 키로 사용하고 dispatch에서 처리하는 방식.
 * var ACTION = axboot.actionExtend(fnObj, {
 *  PAGE_SEARCH: "PAGE_SEARCH",
 *  dispatch: function(caller, act, data){
 *      switch (act) {
 *          case ACTIONS.PAGE_SEARCH:
 *              // call view method
 *          break;
 *          default
 *              return false;
 *      }
 *  }
 * });
 *
 * // ACTION 이름에 함수를 구현하는 방식
 * var ACTION = axboot.actionExtend(fnObj, {
 *  PAGE_SEARCH: function(caller, act, data){
 *
 *  },
 *  dispatch: function(caller, act, data){
 *      var result = ACTIONS.exec(caller, act, data);
 *      if(result != "error"){
 *          return result;
 *      } else {
 *          return false;
 *      }
 *  }
 * });
 *
 * // 액션의 실행
 * fnObj.sampleView = axboot.viewExtend({
 *  initView: function(){
 *      ACTIONS.dispatch(ACTIONS.PAGE_SEARCH);
 *  }
 * });
 * ```
 */
axboot.actionExtend = function () {
    return function (_actionThis, _action) {
        var myAction = {};

        // 액션 명령어는 수집하여 담기
        for (var k in _action) {
            if (ax5.util.isString(_action[k])) {
                myAction[k] = _action[k];
            } else if (ax5.util.isFunction(_action[k])) {
                myAction[k] = k;
                myAction["__EXEC__" + k] = _action[k];
            }
        }

        if ("dispatch" in _action) {
            myAction["page_dispatch"] = _action["dispatch"];
        } else {
            myAction["page_dispatch"] = function (caller, act, data) {
                var result = ACTIONS.exec(caller, act, data);

                if (result != 'error') {
                    return result;
                } else {
                    return false;
                }
            }
        }

        myAction["exec"] = function (caller, act, data) {
            if (_action[act]) {
                return _action[act].call(caller, caller, act, data);
            } else {
                return "error";
            }
        };
        myAction["dispatch"] = function () {
            var fnArgs = [];

            fnArgs = ax5.util.toArray(arguments);

            if (ax5.util.isString(fnArgs[0])) {
                // 첫번째 아규먼트가 문자열이라면. action 이름이 왔다고 보자.
                // 첫번째 아규먼트에 _actionThis 삽입
                fnArgs.splice(0, 0, _actionThis);
            }
            return myAction["page_dispatch"].apply(_actionThis, fnArgs);
        };

        return myAction;
    };
}();
